import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders a label element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the label.
 * @param {Object} [props.children] - Child elements to be rendered inside the label.
 * @returns {JSX.Element} The rendered label component.
 */
export function Label({ className, ...props }) {
  return (
    <Headless.Label
      data-slot="label"
      {...props}
      className={clsx(
        className,
        'select-none text-base/6 text-zinc-950 data-[disabled]:opacity-50 sm:text-sm/6'
      )}
    />
  );
}

Label.propTypes = {
  className: PropTypes.string,
};
